import React from "react";
import { doubleVIvon, orangeVIcon, Close, Calculator} from "../../assets/images";
import Button from "../button";
import { useLayoutContext } from "../../layouts/general-layout";
import "./solution-status-popup.scss";

interface Props {
  onClose: () => void;
}

const SolutionStatusPopup: React.FC<Props> = ({ onClose }) => {
    const { t } = useLayoutContext();

    return (
        <div className="status-popup-overlay">
        <div className="status-popup-container">
            <div className="popup-header">
                <h3 className="popup-title"><img src={Calculator} alt="close" />{t("verifiedunverifiedAnswer")}</h3>
                <button className="close-btn" onClick={onClose}>
                <img src={Close} alt="close" />
                </button>
            </div>

            <div className="popup-body">
            <div className="popup-row">
                <img src={doubleVIvon} alt="approved" className="popup-icon" />
                <p>
                <span className="popup-label approved">{t("verifiedAnswer")} - </span>
                {t("verifiedAnswerInfo")}
                <br />
                {t("correctAnswer")}
                </p>
            </div>

            <div className="popup-row">
                <img src={orangeVIcon} alt="not approved" className="popup-icon" />
                <p>
                <span className="popup-label not-approved">{t("unverifiedAnswer")} - </span>
                {t("unverifiedAnswerInfo")}
                <br />
                {t("ourteachers")}
                </p>
            </div>
            </div>

            {/* Footer */}
            <div className="popup-footer">
            <Button text={t("understand")} color="blue" onClick={onClose} />
            </div>
        </div>
        </div>
    );
};

export default SolutionStatusPopup;
